export class FrontendActivityLog {
    constructor () {}

    init() {
        let _this = this;
        _this.bindEvents();
    }

    bindEvents() {
        let _this = this;

        $('body').on('click', '.add_log_trigger', function() {
            var url = $(this).attr('data-add-log-url');
            var dataActionName = $(this).attr('data-action-name');
            var dataRequestPath = $(this).attr('data-request-path');
            var dataRouteName = $(this).attr('data-route-name');
            var dataQueryParams = $(this).attr('data-query-params');
            var dataAditionalnotes = $(this).attr('data-additionalnotes');

            $.ajax({
                url: url,
                type: 'GET',
                data: {
                    request_path: dataRequestPath,
                    action_name: dataActionName,
                    route_name: dataRouteName,
                    query_params: dataQueryParams,
                    additional_notes: dataAditionalnotes,
                },
                dataType: 'json',
                success: function (res) {},
                error: function () {}
            });
        });
    }
}